module.exports = __webpack_public_path__ + "img/chengyun55.41c9a5d5.png";